import {
    Container,
    VStack,
    Card,
    Button,
    FormControl,
    FormLabel,
    Input,
    HStack,
    Text,
} from '@chakra-ui/react'
import React from 'react'
import { useStoreLocations } from '../../providers/LocationProvider';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';

export default function EditLocation() {

    const { state } = useLocation();

    var { updateData } = useStoreLocations();
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            name: state.name,
            username: state.username,
            password: "",
        },
        onSubmit: async (values) => {
            try {
                await updateData(state.id, values.name, values.username, values.password);
            } catch (error) {
                toast.error("Error Updating !");
            }
        }
    });


    return (
        <Container p='4' maxW='3xl'>
            <VStack width='100%' spacing={4}>

                <Card borderRadius='md' p='4' width={'100%'}>
                    <HStack justifyContent='space-between'>
                        <Text fontWeight='bold' className='customfont' fontSize='2xl'>Update Location</Text>
                    </HStack>
                </Card>

                <Card width={'100%'} p='6'>

                    <form onSubmit={formik.handleSubmit}>
                        <VStack spacing={4} align="flex-start">
                            <FormControl>
                                <FormLabel htmlFor="name">Name</FormLabel>
                                <Input
                                    id="name"
                                    name="name"
                                    type="text"
                                    variant="filled"
                                    required={true}
                                    onChange={formik.handleChange}
                                    value={formik.values.name}
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel htmlFor="username">Username</FormLabel>
                                <Input
                                    id="username"
                                    name="username"
                                    type="text"
                                    variant="filled"
                                    required={true}
                                    onChange={formik.handleChange}
                                    value={formik.values.username}
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel htmlFor="password">Password</FormLabel>
                                <Input
                                    id="password"
                                    name="password"
                                    type="text"
                                    variant="filled"
                                    required={true}
                                    onChange={formik.handleChange}
                                    value={formik.values.password}
                                />
                            </FormControl>

                            <Button type="submit" bg='primary.800' colorScheme="primary" py='6' width="full">
                                Update
                            </Button>

                        </VStack>
                    </form>
                </Card>
            </VStack>
        </Container>
    )
}


